<script setup lang="ts">
const items = [
  'Spreadsheet panjang & rawan salah input',
  'Input pesanan satu per satu habiskan waktu tim',
  'Pengiriman ganda karena alamat duplikat',
  'Laporan manual, sulit pantau progres kiriman'
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Data Pesanan Banyak, Tapi Sistem Belum Terpadu?"
    hero-image="/images/kirim-paket-massal-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <Icon
            class="text-primary flex-none"
            name="material-symbols:verified"
            :size="isMobile ? '22px' : '30px'"
          />
          <p class="text-sm lg:text-lg flex-1">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
